import { render } from "./MoveTable.html?vue&type=template&id=09dcafc5&ts=true&external"
import script from "./MoveTable.vue?vue&type=script&lang=ts"
export * from "./MoveTable.vue?vue&type=script&lang=ts"

import "./MoveTable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__